/* eslint-disable no-fallthrough */
/* eslint-disable no-case-declarations */

import { LOCATION_CHANGE } from 'connected-react-router';
import registry from '../../../registry';

const errorState = {
  previousLocation: null
};

export default function reducer(state = errorState, action) {
  const { payload } = action;

  switch (action.type) {
    case LOCATION_CHANGE: {
      return {
        ...state,
        ...payload
      };
    }

    default:
      return state;
  }
}

registry.register('error', reducer, errorState);
